<div class="ng-container">
  <button type="button"
          class="btn-search-params btn-search-params--dates"
          [disabled]="facade.splitRooms && !facade.newSearchParams?.hotelsSearch"
          (click)="onDatesButtonClick()">
    {{ facade.datesLabel }}
    @if (!facade.newSearchParams?.hotelsSearch) {<br>{{ facade.nightsLabel }}}
  </button>
  <button type="button" class="btn-search-params btn-search-params--tourists" (click)="openModal('tourists')">
    {{ facade.adultsLabel }} <br>{{ facade.childLabel }}
  </button>
</div>

@if (openedModal === 'tourists') {
  <ng-modal [configuration]="modalConfiguration()">
    <ng-container modalContent>
      <app-tourists [initialSearchParams]="facade.newSearchParams" />
    </ng-container>
  </ng-modal>
}

@if (openedModal === 'calendar') {
  <ng-modal [configuration]="modalConfiguration()">
    <ng-container modalContent>
      <div class="calendar-modal">
        <app-hotel-price-calendar />
      </div>
    </ng-container>
  </ng-modal>
}

@if (!isFooterVisible && !facade.splitRooms && !facade.newSearchParams?.hotelsSearch) {
  <button type="button" class="btn btn-blue btn-show-price-calendar" (click)="onPriceCalendarButtonClick()">
    <img src="/x-assets/img/icons/icon-calendar-white.svg" alt=""> Календарь цен
  </button>
}

@if (openedModal === 'stayCalendar') {
  <ng-modal [configuration]="modalConfiguration()">
    <ng-container modalContent>
      <app-hotel-stay-calendar [initialSearchParams]="facade.newSearchParams" />
    </ng-container>
  </ng-modal>
}
